import { all, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import { path, max } from 'ramda';

import * as actionTypes from 'constants/actionTypes';

import { sidebarClose } from 'actions/sidebarActions';

import { setRequestListSelected, setRequestListPagination } from 'actions/requestActions';
import { setApprovalPersonListSelected, setApprovalPersonListPagination } from 'actions/approvalPersonActions';
import { setApprovalProjectListSelected, setApprovalProjectListPagination } from 'actions/approvalProjectActions';

import {
    getRequestCounters,
    getApprovalPersonCounters,
    getApprovalProjectCounters
} from 'actions/asyncActions';

const createApprovalSagas = (GET_LIST, getCounters, UPDATE_ITEM, setSelected, setPagination, tableName) => {
    return function* () {
        yield all([
            takeLatest(GET_LIST, function* () {
                return yield put(getCounters());
            }),
            takeEvery(UPDATE_ITEM, function* ({ payload }) {
                const pagination = yield select(path(['table', tableName, 'pagination']));
                const removedItems = path(['ids', 'length'], payload);

                const actions = [
                    put(setSelected()),
                    put(sidebarClose()),
                    (removedItems >= pagination.linesLeft) && (
                        put(setPagination(max(0, pagination.page - 1)))
                    )
                ];

                return yield all(actions);
            })
        ])
    }
};

export const approvalPerson = createApprovalSagas(
    actionTypes.GET_APPROVAL_PERSON_LIST,
    getApprovalPersonCounters,
    [actionTypes.APPROVE_PERSON, actionTypes.REJECT_PERSON],
    setApprovalPersonListSelected,
    setApprovalPersonListPagination,
    'approvalPerson'
);

export const approvalProject = createApprovalSagas(
    actionTypes.GET_APPROVAL_PROJECT_LIST,
    getApprovalProjectCounters,
    [actionTypes.APPROVE_PROJECT, actionTypes.REJECT_PROJECT],
    setApprovalProjectListSelected,
    setApprovalProjectListPagination,
    'approvalProject'
);

export const request = createApprovalSagas(
    actionTypes.GET_REQUEST_LIST,
    getRequestCounters,
    [actionTypes.CANCEL_REQUEST],
    setRequestListSelected,
    setRequestListPagination,
    'request'
);
